export default class DateOptions extends Number
{
	public static Default = 0;
	public static HideDay = 1 << 0;
	public static HideMonth = 1 << 1;
	public static YearOnly = DateOptions.HideMonth | DateOptions.HideDay;
	// could be extended to have other formats correspond to other bits
	// could be extended to split the field in half to apply to start and end separately 

	public has(options : DateOptions | Number)
	{
		return ((this.valueOf() & options.valueOf()) == options.valueOf());
	}
}